import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid'
import { alpha, styled } from '@mui/material/styles'

export const HeadTable = styled(Grid)(({ theme }) => ({
  background: theme.palette.grey[200],
  padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
  borderRadius: theme.shape.borderRadius,
}))

export const BodyTableHeader = styled(Box)(({ theme }) => ({
  background: theme.palette.grey[200],
  padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
  borderTopLeftRadius: theme.shape.borderRadius,
  borderTopRightRadius: theme.shape.borderRadius,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}))

export const BodyTable = styled(Box)(({ theme }) => ({
  borderRadius: theme.shape.borderRadius,
  border: `1px solid ${theme.palette.divider}`,
}))

export const AddButton = styled(Button)(({ theme }) => ({
  padding: theme.spacing(0.5, 0),
  width: 'auto',
  minWidth: 0,
  background: 'transparent',
  color: theme.palette.primary.main,
  fontWeight: 600,
  '&:hover': {
    background: 'transparent',
    textDecoration: 'underline',
  },
}))

export const AddCategoryButton = styled(Button)(({ theme }) => ({
  padding: theme.spacing(1.5, 2),
  width: '100%',
  justifyContent: 'flex-start',
  textAlign: 'left',
  textTransform: 'none',
  borderRadius: theme.shape.borderRadius * 2,
  background: alpha(theme.palette.primary.main, 0.04),
  border: `1px dashed ${theme.palette.primary.main}`,
  '&:hover': {
    background: alpha(theme.palette.primary.main, 0.08),
  },
}))
